@if (mainFilename$ | async; as mainFilename) {
  <gege-angebot
    *axLazyElement="'gege-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></gege-angebot>
}
